// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__uritT","header":"ReportDetails_header__2DcK7","title":"ReportDetails_title__1ApiH","left":"ReportDetails_left__2_I73"};